import { Component, Input, OnDestroy, forwardRef } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ServiceLine } from '../../interface/service-line.interface';

@Component({
  selector: 'app-service-line-multiselect',
  templateUrl: './service-line-multiselect.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ServiceLineMultiselectComponent),
      multi: true
    }
  ]
})
export class ServiceLineMultiselectComponent implements ControlValueAccessor, OnDestroy {
  @Input() serviceLines: ServiceLine[] = [];

  readonly control = new FormControl<number[]>([]);

  private destroy$ = new Subject<void>();
  private onChange: (value: number[]) => void = () => {};
  private onTouched: () => void = () => {};

  constructor() {
    this.control.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(value => {
        this.onChange(value || []);
        this.onTouched();
      });
  }

  writeValue(value: number[]): void {
    this.control.setValue(value || [], { emitEvent: false });
  }

  registerOnChange(fn: (value: number[]) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    if (isDisabled) {
      this.control.disable({ emitEvent: false });
    } else {
      this.control.enable({ emitEvent: false });
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
